import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { AlbumFolderForWebGalleries } from '../../graphql/queries/album-folder';
import Spinner from '../../../../components/global/Spinner';
import { openAlert as openAlertAction } from '../../../../actions/modal-actions';
import ContributorActions from '../../../pro/views/AutoContributorLinkHandler/components/ContributorActionsModal/ContributorActions';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  account: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  loading: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  onRequestClose: PropTypes.func.isRequired,
  openAlert: PropTypes.func,
};

// Design taken from ProOnboardingCTA.js.
const WebGalleryProOnboardingInterstitial = ({
  albumFolder,
  loading,
  onRequestClose,
  openAlert,
}) => {
  useEffect(() => {
    if (!loading && !albumFolder) {
      onRequestClose();
      openAlert({
        message:
          "It looks like we couldn't find the gallery you are looking for.",
      });
    }
  }, [loading, albumFolder]);

  if (loading && !albumFolder) {
    // Return spinner
    return (
      <div className="p-5 d-flex">
        <Spinner className="m-auto" />
      </div>
    );
  }

  return (
    <ContributorActions entity={albumFolder} onViewPhotos={onRequestClose} />
  );
};

WebGalleryProOnboardingInterstitial.propTypes = propTypes;

const withAlbumFolderForWebGalleries = graphql(AlbumFolderForWebGalleries, {
  options: ({ albumFolderId }) => ({
    variables: {
      id: albumFolderId,
    },
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loading,
    account: albumFolder?.account,
  }),
  skip: ({ albumFolderId }) => !albumFolderId,
});

const mapDispatchToProps = {
  openAlert: openAlertAction,
};

export default compose(
  withRouter,
  connect(null, mapDispatchToProps),
  withAlbumFolderForWebGalleries,
)(WebGalleryProOnboardingInterstitial);
